// extracted by mini-css-extract-plugin
export var childrenContainer = "_4c-0";
export var virtualScrollArea = "_4c-1";